<label
    [attr.for]="for" 
    [ngClass]="labelClasses" 
    [ngStyle]="styles" 
    [attr.title]="title" >
    @if (selectionIcon) {
        <fa-icon [icon]="selectionIcon"></fa-icon>
    }
    <ng-content></ng-content>
</label>